// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DatabaseMapping.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Database Mapping component
 */
import React, { Component } from 'react';

import ActionBar from 'modules/Settings/DataSetup/DatabaseMapping/ActionBar/Izenda.ActionBar';
import actions from 'modules/Settings/DataSetup/DatabaseMapping/Izenda.DatabaseMappingActions';
import MappingDetail from 'modules/Settings/DataSetup/DatabaseMapping/MappingDetail/Izenda.MappingDetail';
import connect from 'share/enhancers/Izenda.Connect';

class DatabaseMapping extends Component {
  componentDidMount() {
    this.props.initial(this.props);
  }

  componentWillUnmount() {
    this.props.destroy(this.props.store);
  }

  render() {
    const { store } = this.props;

    return (
      <div className="izenda-DatabaseMapping izenda-TableLayout">
        <div className="izenda-DatabaseMappingInner izenda-TableLayout-Cell">
          <section className="izenda-Wrapper">
            <section className="izenda-Wrapper-header">
              <ActionBar store={store} />
            </section>
            <MappingDetail store={store} />
          </section>
        </div>
      </div>
    );
  }
}

export default connect(actions)(DatabaseMapping);



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DatabaseMapping/Izenda.DatabaseMapping.js